<template>
  <v-container class="pa-0">
    <v-card flat rounded="0">
      <v-card-title>
        <h1 class="text-h1 text-wrap">{{ getAnnuitiesTitle }}</h1>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row class="text-center">
          <v-col cols="12" sm="4" mt-4>
            <PolicyDetailsInfo
              :title="$t('L_value')"
              :content="'$' + policy.data.totalAnnuityCoverage"
            />
          </v-col>
          <v-col cols="12" sm="4" mt-4>
            <PolicyDetailsInfo
              :title="$t('L_policy_annuities_issue_date')"
              :content="annuityIssueDate"
            />
          </v-col>

          <!-- For information on withdrawing...  -->
          <v-col cols="12" class="font-size--16 text-left pl-4 mt-4 pr-4">
            <span class="font-weight-bold">
              {{ $t('L_For_information_on_withdrawing_or_surrendering_funds') }}
            </span>
            <span @click="openAnnuityWithDrawalLink" class="clickHere font-weight-bold">
              {{ ' ' + $t('L_click_here') }}
            </span>
          </v-col>
        </v-row>
        <v-spacer class="mt-4" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { openInNewWindow } from '@/mixins/openNewWindow';
import PolicyDetailsInfo from '../PolicyDetailsInfo.vue';
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import { format } from 'date-fns';

const componentOptions: ComponentOptions = {
  name: 'AnnuitiesComponent',
  mixins: [openInNewWindow],
  components: {
    PolicyDetailsInfo,
  },
  data: () => ({
    showAnnuityDetail: false,
  }),
  computed: {
    ...mapState(useGlobalStore, {
      currentLocale: 'getLocale',
    }),
    ...mapState(usePolicyStore, {
      policy: 'currentPolicy',
    }),
    annuityIssueDate() {
      const datestr = this.policy.annuity[0].phIssueDate || this.policy.annuity[0].issueDate;
      return format(datestr, 'MM/dd/yyyy');
    },
    annuityText() {
      return this?.policy?.annuity[0]?.planzText?.replace(/#\$#/g, '<br>');
    },
    getAnnuitiesTitle() {
      if (this.policy != null) {
        if (this.currentLocale === 'fr_CA') {
          return this.policy?.annuity[0]?.planDescriptionFrench;
        }
        return this.policy?.annuity[0]?.planDescription;
      }
      return '';
    },
  },
  methods: {
    hideTooltip() {
      this.showAnnuityDetail = false;
      document.removeEventListener('click', () => this.hideTooltip());
    },
    async openAnnuityWithDrawalLink() {
      let annuityUrl = '';
      const isWeb = CapacitorFacade.isWeb();
      // https://primerica-auth2-stg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=210414162646110&page=1&position=0&q=surrender&sl=true%22
      if (this.currentLocale === 'en_US') {
        // 210414162646110
        annuityUrl = window.appConfig.life.Annuity_Withdrawal_US_en;
      } else if (this.currentLocale === 'en_CA') {
        // 210414162646110
        // https://primerica-auth2-stg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=210414162646110&page=1&position=0&q=surrender&sl=true%22
        annuityUrl = window.appConfig.life.Annuity_Withdrawal_CA_en;
      } else if (this.currentLocale === 'fr_CA') {
        // 221108170824537
        // https://primerica-auth2-stg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=221108170824537&page=1&position=0&q=Retrait%20d%27Avantage&sl=true%22
        annuityUrl = window.appConfig.life.Annuity_Withdrawal_CA_fr;
      }
      await this.openInNewWindow({
        url: annuityUrl,
        inappbrowser: !isWeb,
        target: 'RADashboardWinName',
      });
    },
    toggleTooltip(e: Event) {
      if (!this?.annuityText?.length) {
        return;
      }
      this.showAnnuityDetail = !this.showAnnuityDetail;
      e.stopImmediatePropagation();
      if (this.showAnnuityDetail) {
        document.addEventListener('click', () => this.hideTooltip());
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
h3.heading_three {
  a {
    font-weight: inherit !important;
  }

  a[disabled] {
    color: #333 !important;
    text-decoration: none !important;
    cursor: default !important;
  }
}

.lh1 {
  line-height: 1em;
}

.opaque {
  opacity: 1 !important;
}

.clickHere {
  cursor: pointer;
  color: #0c6dca;
}
</style>
